module.exports = __webpack_public_path__ + "static/media/1011062.e936ac10.jpg";